export const NuxtApollo = {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true, "sameSite": "lax"},
 clients: {"default": {"httpEndpoint": "undefined/graphql", "authType": "Bearer", "authHeader": "Authorization", "tokenName": "apollo:default.token", "tokenStorage": "cookie", "defaultOptions": undefined}, "statamic": {"httpEndpoint": "undefined/graphql", "tokenName": "statamic-token", "authType": "Bearer", "authHeader": "Authorization", "tokenStorage": "cookie", "defaultOptions": undefined}}
}